/// <reference path="app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var ReportingConfig = /** @class */ (function () {
        function ReportingConfig() {
        }
        ReportingConfig.configure = function ($compileProvider, $locationProvider, $logProvider, $routeProvider, $translateProvider, appSettings) {
            $locationProvider.hashPrefix('');
            $compileProvider.debugInfoEnabled(appSettings.angularDebugEnabled);
            if (!ap.Utilities.isNullOrUndefined($logProvider.debugEnabled)) {
                $logProvider.debugEnabled(true);
            }
            var routes = ap.Constants.routes;
            $routeProvider
                .when("/" + routes.reporting.route, routes.reporting)
                .when("/" + routes.reportDisplay.route + "/:report?/:organizationCacheKey?", routes.reportDisplay)
                .otherwise("/" + routes.reporting.route, routes.reporting);
            $translateProvider.translations();
            $translateProvider.preferredLanguage('en');
            $translateProvider.useSanitizeValueStrategy('escapeParameters');
        };
        ReportingConfig.configureCookies = function ($cookiesProvider, appSettings) {
            $cookiesProvider.defaults.domain = appSettings.cookieDomain;
        };
        return ReportingConfig;
    }());
    angular.module('app')
        .config(['$compileProvider', '$locationProvider', '$logProvider', '$routeProvider', '$translateProvider', 'appSettings', ReportingConfig.configure])
        .config(['$cookiesProvider', 'appSettings', ReportingConfig.configureCookies]);
    angular.module('deploy', []).constant('appSettings', {
        angularDebugEnabled: true,
        applicationCacheKey: '3dcc11f0-1ffc-4d5e-8804-11a22cbaa13e',
        cookieDomain: '.local.autopoint.com',
        //develop
        urls: {
            apiUrl: 'http://reportingapi.local.autopoint.com',
            avenueWeb: 'http://avenue.local.autopoint.com',
            dynamicContentUrl: 'http://dynamiccontent.local.autopoint.com',
            mediaApiUrl: 'http://mediaapi.local.autopoint.com',
            sso: 'http://sso.local.autopoint.com',
            ssoApi: 'http://ssoapi.local.autopoint.com',
            ssrsUrl: 'http://apsjodvsql05/',
            wpUrl: 'https://welcomepoint.local.autopoint.com'
        }
    });
})(app || (app = {}));
